/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibraryloaderror3Inputs */

const en_medialibraryloaderror3 = /** @type {(inputs: Medialibraryloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the media library.`)
};

const de_medialibraryloaderror3 = /** @type {(inputs: Medialibraryloaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Mediathek konnte nicht geladen werden.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the media library." |
*
* @param {Medialibraryloaderror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryloaderror3 = /** @type {((inputs?: Medialibraryloaderror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryloaderror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryloaderror3(inputs)
	return de_medialibraryloaderror3(inputs)
});
export { medialibraryloaderror3 as "mediaLibraryLoadError" }